import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId } from '/imports/domain';

export const ExamPageParams = iots.strict({
  semester: SemesterId,
  courseUrl: CourseUrl,
});

export type ExamPageParams = iots.TypeOf<typeof ExamPageParams>;
